import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const subheader: SugarElementInfo = {
    name: "subheader",
    availableChildren: { type: AvailableChildrenType.Any },
};
